<template>
    <div class="template_wrapper">
        <div class="template_title"><span style="color:red;vertical-align: top;" v-if="moduel.required==1" >*</span>{{moduel.name}}</div>
        <el-select
          v-if="moduel.key_name != 'customer_ids'"
          v-model="options"
          multiple
          filterable
          popper-class='dropWrapper'
          :filter-method="nameInput"
          @change="getUsername"
          placeholder="请输入人员">
          <el-option
            v-if="check_user_inuse(item.user_id) === false && options.indexOf(item.user_id) < 0"
            v-for="(item,key) in user_list"
            :key="key"
            :label="item.username"
            :value="item.user_id"
          >
          </el-option>
        </el-select>

        <el-select
          v-if="moduel.key_name == 'customer_ids'"
          v-model="options"
          multiple
          filterable
          :filter-method="customerInput"
          @change="getClientInfo"
          placeholder="请输入客户名称">
          <el-option
            v-if="options.indexOf((item.khjc == '' || item.khjc == null)?item.khmc:item.khjc) == -1"
            v-for="(item,key) in customer_list"
            :key="key"
            :label="(item.khjc == '' || item.khjc == null)?item.khmc:item.khjc"
            :value="(item.khjc == '' || item.khjc == null)?item.khmc:item.khjc"
          >
          <span style="float: left">{{ item.khmc }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.khjc }}</span>
          </el-option>
        </el-select>
        <!-- <span style="color:red;" v-if="moduel.required==1" >*</span> -->
        <!-- <span v-if="moduel.required!=1" >选填</span> -->
        <div style="width:auto;word-wrap:break-word;position:fixed;left:-10000px;font-size: 14px;line-height:22px;height:22px;" ref="computed_content_input" v-html='role_selected_str'></div>
    </div>
</template>
<style>

</style>
<script>
export default {
  name: 'selectObj',
  data () {
    return {
        saving: false,
        options: [],
        role_selected:[],
        user_list:[],
        customer_list:[],
        web_token:'',
        web_url:'',
        role_selected_str:''
    }
  },
  // store,
  props: ['moduel','projectData','type','input_callback'],
  methods:{
    backToLogin(){
      this.$router.push('/login');
    },
    //获取i项目人员名字
    getUsername(user){
      var has_selected = this.projectData[this.moduel.key_name];
      console.log(JSON.parse(JSON.stringify(has_selected)));
      var user_all = [];
      
      var subs = [];
      var adds = [];
      for(var i =0; has_selected.length > i; i++){
        var selected_item = has_selected[i];
        var sub = true;
        for(var user_index = 0;user_index<user.length;user_index ++)
        {
          var user_item = user[user_index];
          if(user_item == selected_item.user_id || user_item == selected_item.username) {
            sub = false;
            break;
          }
        }
        if(sub) {
          subs.push(i);
          break;
        }
      }
      for(var i =0; user.length > i; i++){
        var user_item = user[i];
        var add = true;
        for(var selected_index = 0; selected_index < has_selected.length;selected_index++){
          var selected_item = has_selected[selected_index];
          if(user_item === selected_item.user_id) {
            add=false;
            break;
          }
        }
        if(add) adds.push(user_item);
      }

      subs = subs.sort(function(a,b){ return a < b; });
      for(var sub_index=subs.length - 1;sub_index >= 0;sub_index--){
        console.log("减去了", has_selected[subs[sub_index]]);
        has_selected.splice(subs[sub_index], 1);
      }

      var add_objects = [];
      for(var add_index =0; add_index < adds.length; add_index++){
        var add_item = adds[add_index];
        for(var i = 0;i<this.user_list.length;i++){
          var search_user_item = this.user_list[i];
          if(add_item == search_user_item.user_id){
            add_objects.push(
              {
                user_id:search_user_item.user_id,
                username:search_user_item.username
              }
            );
          }
        }
      }
      
      user_all = has_selected.concat(add_objects);
      this.$emit('input', user_all);
      
      // 计算宽度
      var allUsers = this.projectData.join_user_ids.concat(this.projectData.manage_user_ids).concat(this.projectData.leader_user_ids);
      var allUsersArray = [];
      var that = this;
      for(var _index =0; _index < allUsers.length; _index++){
        var _item = allUsers[_index];
        allUsersArray.push(_item.username);
      }
      this.role_selected_str = allUsersArray.join(',');
      this.$nextTick(function(){
          var _content_Width = that.$refs["computed_content_input"].offsetWidth;
          that.input_callback(_content_Width);
      });
    },
    getClientInfo(client){
      var has_seclected = this.projectData[this.moduel.key_name];
      var cur_seclected  = [];
      var client_all = [];
      var that = this;
      console.log("控件执行getClientInfo",client);
      console.log("已选择", JSON.stringify(has_seclected));
      if(has_seclected.length > client.length){
        // 减
        var subs = [];
        for(var i =0; has_seclected.length > i; i++){
          if(client.indexOf(has_seclected[i].khjc) < 0) subs.push(i);
        }
        subs = subs.sort(function(a,b){ return a < b; });
        console.log(subs);
        for(var sub_index=subs.length - 1;sub_index >= 0;sub_index--){
          console.log("减去了", has_seclected[subs[sub_index]]);
          has_seclected.splice(subs[sub_index], 1);
        }
        client_all = has_seclected;
      }else {
        //加
        for(var i =0; client.length > i; i++){
          var in_select = false;
          for(var has_index = 0;has_index<has_seclected.length;has_index++) {
            if(has_seclected[has_index].khjc === client[i]) in_select = true;
          }
          if(in_select === false){
            for(var a =0; this.customer_list.length > a; a++){
              if( client[i] == this.customer_list[a].khjc){
                console.log("加上了",client[i], this.customer_list[a].khjc);
                has_seclected.push({ khmc:this.customer_list[a].khmc,khdm:this.customer_list[a].khdm,clientlevel:this.customer_list[a].clientlevel,khjc:this.customer_list[a].khjc});
              }
            }
          }
        }
        client_all = has_seclected;
      }
      this.$emit('input', client_all);

      // 计算宽度
      var clientsArray = [];
      for(var _index =0; _index < client_all.length; _index++){
        var _item = client_all[_index];
        clientsArray.push(_item.khmc);
      }
      this.role_selected_str = clientsArray.join(',');
      this.$nextTick(function(){
          var _content_Width = that.$refs["computed_content_input"].offsetWidth;
          that.input_callback(_content_Width);
      });
      // this.$emit('listenToChildEvent',this.type);
    },
    check_user_inuse(_user){
      for(var i=0;i<this.role_selected.length;i++) {
        var role_item = this.role_selected[i];
        if(_user == role_item.user_id || _user == role_item.username) return true;
      }
      return false;
    },
    //搜索人员
    nameInput:function(query){
        var list_in_options = this.projectData[this.moduel.key_name];
        if(query == ''){
            this.user_list = [];
            return false;
        }
        this.$http.post(this.web_url+'/user_list',{web_token:this.web_token,keyword:query},{emulateJSON:true}).then(function(res){
            if(res.data.status == 'ok'){
                 this.user_list = [];
                 var list = res.data.data;
                 var list2 = [];
                 for(var i =0; i <  list.length; i++){
                    if(this.options.indexOf(list[i].username) == -1){
                          list2.push(list[i]);
                    }
                }
                // this.user_list = list_in_options.concat(list2);
                this.user_list = list2;
            }else {

            }
          // console.log(this.role_selected)
        })
        .catch(function(res1){
          // console.log(res1);
        });
    },
    //搜索客户
    customerInput:function(query){
        var list_in_options = this.projectData[this.moduel.key_name];
      if(query == ''){
         this.customer_list = [];
        return false;
      }
      var that = this;
      this.$http.post(this.web_url+'/customer_list',{web_token:this.web_token,keyword:query},{emulateJSON:true}).then(function(res){
        if(res.data.status == 'ok'){
          this.customer_list = [];
          var list = res.data.data;
          var list2 = [];
          for(var i =0; i <  list.length; i++){
              if(this.options.indexOf(list[i].khjc) == -1){
                    list2.push(list[i]);
              }
          }
          this.customer_list = list2.concat(that.projectData[this.moduel.key_name]);
          // this.customer_list = list_in_options.concat(list2);
        }else {
        }
      })
      .catch(function(res1){
        console.log(res1);
      });
    },
    getUsers:function(){
      this.$http.post(this.web_url+'/user_list',{web_token:this.web_token,keyword:this.keyword},{emulateJSON:true}).then(function(res){
        if(res.data.status == 'ok'){
          this.user_list = res.data.data;
        }else {

        }
      })
      .catch(function(res1){
        console.log(res1);
      });
    },
    clear(){
        this.options = [];
        this.user_list = [];
    },
    //  项目人员有变化
    user_change(){
      if( 'join_user_ids' in this.projectData && 'leader_user_ids' in this.projectData && 'manage_user_ids' in this.projectData){
        if(this.moduel.key_name == 'leader_user_ids'){
          this.role_selected = this.projectData.join_user_ids.concat(this.projectData.manage_user_ids);
        }

        if(this.moduel.key_name == 'join_user_ids'){
          this.role_selected = this.projectData.manage_user_ids.concat(this.projectData.leader_user_ids);
        }

        if(this.moduel.key_name == 'manage_user_ids'){
          this.role_selected = this.projectData.join_user_ids.concat(this.projectData.leader_user_ids);
        }
      }
    },
    refresh(){
      this.user_change();
      if(this.projectData[this.moduel.key_name] == undefined || this.projectData[this.moduel.key_name] == []){
          return false;
      }
      this.options = [];
      if(this.moduel.key_name != 'customer_ids' && this.projectData[this.moduel.key_name].length > 0){
          this.options_selected = this.projectData[this.moduel.key_name];
          for(var i =0; this.options_selected.length > i; i++){
            this.options.push(this.options_selected[i].username);
          }
         
      }

      if(this.moduel.key_name == 'customer_ids' && this.projectData[this.moduel.key_name].length > 0){
          this.options_selected = this.projectData[this.moduel.key_name];
          for(var i =0; this.options_selected.length > i; i++){
            var item = this.options_selected[i];
            var show_client = item.khjc === null ? item.khmc : item.khjc ;
            this.options.push(show_client);
          }
      }
    }

  },
  activated(){
  },
   beforeDestroy(){
      this.clear();
  },
  destroyed(){
      
  },
  mounted() {
    this.web_token = sessionStorage.getItem('web_token');
    this.web_url =  sessionStorage.getItem('web_url');
    this.user_info =JSON.parse(sessionStorage.getItem('user_info'));

    this.refresh();
  },
  watch: {
  },
  computed: {
  }
}
</script>
<style>
  .el-select-dropdown__empty{
    display: none!important;
    position: fixed;
    top: -9999px!important;
  }
  .popper__arrow{
    position: fixed;
    top: -9999px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/selectObj_user.vue